// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"platform-alert-timer_uk-open__9zPKn","grecaptcha-badge":"platform-alert-timer_grecaptcha-badge__9V4Fo","timer":"platform-alert-timer_timer__nBZjx","time":"platform-alert-timer_time__CvZ5Z","timeUnit":"platform-alert-timer_timeUnit__9hMgc"};
    if(module.hot) {
      // 1751268261624
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  